import React, { FC, ReactNode } from 'react';
import cn from 'classnames';

export const TextColor = {
  default: 'text-astronautBlue',
  hover: 'hover:text-bahamaBlue',
  active: 'active:text-prussianBlue',
  disabled: 'disabled:text-grayText'
};

interface Props extends React.HTMLProps<HTMLButtonElement> {
  onClick?: (event: React.FormEvent<HTMLButtonElement>) => void;
  buttonLabel?: ReactNode;
  className?: string;
  disabled?: boolean;
  type?: 'submit' | 'reset' | 'button' | undefined;
  textColor?: typeof TextColor;
}
const Button: FC<Props> = ({
  buttonLabel,
  onClick,
  className = '',
  disabled = false,
  ...otherProps
}) => {
  return (
    <button
      className={cn(
        'flex items-center justify-center rounded-md mx-auto',
        disabled && 'cursor-not-allowed',
        TextColor.default,
        TextColor.hover,
        TextColor.active,
        TextColor.disabled,
        'bg-gallery',
        className
      )}
      onClick={onClick}
      disabled={disabled}
      {...otherProps}
    >
      <div
        className={cn(
          'px-[16px] py-[8px] h-[48px] min-w-[328px] flex justify-center items-center'
        )}
      >
        <div
          className={cn(
            'flex justify-center items-center w-full rounded-r-md fs-body-bold'
          )}
        >
          {buttonLabel}
        </div>
      </div>
    </button>
  );
};
export default Button;
